import React from 'react';
import { connect } from 'react-redux';
import {Route} from "react-router-dom";

const PublicRoute = ({ component: Component, restricted = true, isAuthenticated, ...props }) => {

    return (
      <Route {...props} render={props => (
          <Component {...props} />
      )} />
    );
};

const mapStateToProps = state => ({
    isAuthenticated: state.session.accessToken !== '' ? true : false
});

export default connect(mapStateToProps, null)(PublicRoute);
